function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.8209 10.4348L18.6165 18.2609H4.20958L3.00523 10.4348H19.8209ZM21.8478 8.69565H0.978271L2.7174 20H20.1087L21.8478 8.69565ZM4.18523 1.73913L3.58697 0H19.2209L18.6957 1.73913H4.18523ZM4.32958 6.95652L3.96871 5.21739H18.8565L18.5174 6.95652H20.2826L20.9783 3.47826H1.84784L2.54349 6.95652H4.32958ZM14.8913 13.0435C14.8913 12.5635 14.5026 12.1739 14.0217 12.1739H8.80436C8.32349 12.1739 7.93479 12.5635 7.93479 13.0435C7.93479 13.5235 8.32349 13.913 8.80436 13.913H14.0217C14.5026 13.913 14.8913 13.5235 14.8913 13.0435Z",
  fill: "#C1C1C1"
});

function SvgEmptyPositionsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPositionsIcon);
export default __webpack_public_path__ + "static/media/empty-positions-icon.619bffeb85bff20108686257dc96d4cc.svg";
export { ForwardRef as ReactComponent };